<template>
  <div class="text-center mb-2">
    <v-row
      v-for="(field, index) in alarmPhone"
      :key="index"
      align="center"
      class="px-3 py-2"
    >
      <v-col cols="11" xs="10" class="p-0">
        <VuePhoneNumberInput
          default-country-code="DK"
          :translations="translations"
          v-model="alarmPhone[index]"
          @update="(val) => $emit('updatePhone', val, index)"
        />
      </v-col>

      <v-col cols="1" xs="2" class="p-0">
        <v-btn
          v-if="index !== 0"
          fab
          x-small
          outlined
          color="error"
          @click="confirmDelete(index)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>

        <v-btn v-else @click="addField" fab x-small outlined density="compact">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { translateFunc } from '../common/Filters';
import VuePhoneNumberInput from 'vue-phone-number-input';

export default {
  name: 'AlarmPhoneNumbers',
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      // alarmPhone: [''],
      translations: {
        phoneNumberLabel: translateFunc('lng_phone_alarm_label'),
      },
    };
  },
  props: {
    alarmPhone: {
      type: Array,
      default: () => [''],
    },
  },
  watch: {
    // alarmsms: function(newVal) {
    //   this.alarmPhone[0] = newVal;
    //   this.$set(this.alarmPhone, 0, newVal);
    // },
  },
  mounted() {
    // this.$set(this.alarmPhone, 0, this.alarmsms);
  },
  methods: {
    addField() {
      this.alarmPhone.push('');
    },
    confirmDelete(index) {
      this.alarmPhone.splice(index, 1);
      this.$emit('updatePhone', 'delete', index)
    },
  },
};
</script>
<style scoped></style>
